import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\EstablishInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
const EstablishInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: EstablishInvoiceController.url(args, options),
    method: 'put',
})

EstablishInvoiceController.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}/establish',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Invoice\EstablishInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
EstablishInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return EstablishInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\EstablishInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
EstablishInvoiceController.put = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: EstablishInvoiceController.url(args, options),
    method: 'put',
})

export default EstablishInvoiceController